import { connect } from 'react-redux';
import DuplicateModal from '../duplicate/DuplicateModal';
import { duplicateOtherEquipment } from '../../redux/other_equipment/equipment_actions';


const mapStateToProps = state => ({
  isDuplicating: state.other_equipment.isDuplicating,
  errorMessage: state.other_equipment.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateOtherEquipment(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/other_equipments/OtherEquipmentDuplicateModal.js